import { render, staticRenderFns } from "./upLoadFile.vue?vue&type=template&id=7c613f33"
import script from "./upLoadFile.vue?vue&type=script&lang=js"
export * from "./upLoadFile.vue?vue&type=script&lang=js"
import style0 from "./upLoadFile.vue?vue&type=style&index=0&id=7c613f33&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "upLoadFile.vue"
export default component.exports